<template>
	<div id="Sales" class="sales">
		<list-shippings-request-component></list-shippings-request-component>

		<!-- Modal -->
		<div class="modal fade" id="modalSetingModule" tabindex="-1" aria-labelledby="modalSetingModuleLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="modalSetingModuleLabel">Configuraciones del Modulo</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group row">
							<label for="printerWebSocketServer" class="col-sm-3 col-form-label">Impresora de Etiqueta</label>
							<div class="col-sm-6">
								<select class="form-control form-control-sm" id="printerWebSocketServer" :disabled="!successFullConnectionWebSocketServer" v-model="indexSelectedPrinterWebSocketServer" @change="changeSelectedPrinterWebSocketServer">
									<option v-for="(item, index) in listPrinterWebSocketServer" :value="index" :key="index">{{ item }}</option>
								</select>
							</div>
							<div class="col-sm-2">
								<button class="btn btn-primary btn-sm" @click="toPrintWithVariables" :disabled="!successFullConnectionWebSocketServer">Imprimir</button>
							</div>
						</div>
						<div class="form-group row">
							<label for="printerFacturacionCLPrint" class="col-sm-3 col-form-label">Impresora de Boletas</label>
							<div class="col-sm-6">
								<select class="form-control form-control-sm" id="printerFacturacionCLPrint" :disabled="!successFullConnectionFacturacionCLPrint" v-model="indexSelectedPrinterFacturacionCLPrint" @change="changeSelectedPrinterFacturacionCLPrint">
									<option v-for="(item, index) in listPrinterFacturacionCLPrint" :value="index" :key="index">{{ item }}</option>
								</select>
							</div>
							<div class="col-sm-2">
								<button class="btn btn-primary btn-sm" @click="toPrintFacturacionCL(39, 1)" :disabled="!successFullConnectionFacturacionCLPrint">Imprimir</button>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>

		<shipping-modal-component ref="shippingModalComponent" :item="objectShipping" @getInfoShippingCourrier="getInfoShippingCourrier"></shipping-modal-component>
   		<button class="btn-link" data-toggle="modal" data-target="#shippingModalComponent" ref="btnShowShippingModalComponent" v-show="1 == 0">Abrir ventana Envio</button>

		<starken-modal-component ref="starkenModalComponent" :item="itemSelectedStarken"></starken-modal-component>
   		<button class="btn-link" data-toggle="modal" data-target="#starkenModalComponent" ref="btnShowStarkenModalComponent" v-show="1 == 0"></button>
		
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import genesys from '@/mixins/genesys'
import movimiento from '@/mixins/genesys/movimiento.js'
import domicilio from '@/mixins/genesys/domicilio.js'
import transport from '@/mixins/transports'
import shippingRequest from '@/mixins/shippingsRequest'
import status from '@/mixins/status'
import facturacionCLPrint from '@/mixins/facturacionCLPrint.js'
import webSocketServer from '@/mixins/webSocketServer.js'
import trackingShippingRequest from '@/mixins/shippingsRequest/trackingShippingRequest.js'
import label from "@/mixins/labels/"
import starken from "@/mixins/starken/"
import shipping from '@/mixins/shippings'
import order from '@/mixins/orders'

import Pagination from '@/components/Pagination.vue'
import StarkenModalComponent from '@/components/StarkenModalComponent.vue'
import ShippingModalComponent from '@/components/ShippingModalComponent.vue'
import ContextMenu from '@/components/ContextMenu.vue'
import ListShippingsRequestComponent from '@/components/ListShippingsRequestComponent.vue'

export default {
	name: 'Sales',
	mixins: [axiosAction, errors, mixin, facturacionCLPrint, transport, trackingShippingRequest, shippingRequest, status, genesys, movimiento, domicilio, webSocketServer, label, starken, shipping, order],
	data() {
		return {
			d:0,
			brutocomp: 0,
			cargadoa: '',
			cobro: 0,
			cobroValor: 30000,
			codbareti: '',
			comentario: '',
			comuna: '',
			direccion: '',
			enviara: '',
			rut: '',
			email: '',
			fecmov: '',
			notClose: false,
			nrocomp: '',
			nrocompLegal: '',
			fecmovLegal: '',
			succodLegal: '',
			observtext: '',
			searching: false,
			succod: '',
			telefono: '',
			tipocompcod: 0,
			tipocompcodSearch: 20,
			transportId: 0,
			transportName: '',
			transportSynthetic: '',
			socket: null,
			nameLocalStorageStatus: 'status'
		}
	},
	computed: {
	},
	methods: {
		close() {
			alert('hizo afuera')
		},
		actionSelectMenuItemStatusLocal(data) {
		},
		actionBlurMenuListStatusLocal(data) {
			this.getAllShippingsRequestLocal(1)
		},
		analizarResultado(response) {
			console.log(response)
			if(response.data.data.cabmov.fecmov != '' && response.data.data.cabmov.succod != '') {
				this.tipocompcod = response.data.data.cabmov.tipocompcod
				this.fecmov = response.data.data.cabmov.fecmov
				this.succod = response.data.data.cabmov.succod
				this.codbareti = response.data.data.cabmov.codbareti
				if(response.data.data.cabmov.tipocompcod != 2) {
					this.consultarBoleta(response.data.data.movrel)
					this.consultarClienteEnvio(response.data.data.climov)
					this.consultarCobro(response.data.data.cabmov.brutocomp)
					this.consultarObservacion(response.data.data.observmov)
				}
			} else {
				alert('No se encontró el comprobante')
			}
		},
		clearForm() {
			this.brutocomp = 0
			this.cargadoa = ''
			this.cobro = 0
			this.codbareti= ''
			this.comentario = ''
			this.comuna = ''
			this.direccion = ''
			this.enviara = ''
			this.rut = ''
			this.email = ''
			this.fecmov = ''
			this.succod = ''
			this.tipocompcod = 0
			this.nrocompLegal = ''
			this.fecmovLegal = ''
			this.succodLegal = ''
			this.tipocompcodLegal = 0
			this.observtext = ''
			this.comentario = ''
			this.telefono = ''
			this.transportId = 0
			this.transportName = ''
			this.clearObjectShippingRequest()
		},
		closeModalAttentionOrder() {
			this.nrocomp = ''
			this.clearForm()
		},
		changeStatusShippingRequest(item) {
			let trackingsShippingRequestId = (!item.consider) ? 3 : 2
			this.addShippingRequestTrackingsShippingRequest(item.id, trackingsShippingRequestId)
		},
		consultarBoleta(movrel) {
			for (var index in movrel) {
				if(movrel[index]['tipocompcodrel'] == 1) {
					this.nrocompLegal = movrel[index]['nrocomprel']
					this.fecmovLegal = movrel[index]['fecmovrel']
					this.succodLegal  =movrel[index]['succodrel']
					this.tipocompcodLegal  =movrel[index]['tipocompcodrel']
					this.codbaretiLegal  =movrel[index]['getcodbaretirel']
				}
			}
		},
		consultarClienteEnvio(climov) {
			if(climov.length == 1) {
				this.cargadoa = climov[0].cargadoa
				this.getDomicilioWithCliente(climov[0].domicod)
				this.consultarTransporte(climov[0].trandesc)
			}
		},
		consultarCobro(brutocomp) {
			this.cobro = (brutocomp < this.cobroValor) ? 0 : 1
			this.brutocomp = brutocomp
			this.objectShippingRequest.totalPrice = this.brutocomp
		},
		consultarObservacion(obsermov) {
			for (var index in obsermov) {
				if(obsermov[index]['resaltar'] == 3)
					this.observtext = obsermov[index]['observtext']
			}
		},
		consultarTransporte(trandesc) {
			if(trandesc !== null)
				switch (trandesc.toUpperCase().trim().replace(/(\r\n|\n|\r)/gm, "")) {
					case 'STARKEN':
					case 'TUR BUS':
					case 'TURBUS':
						this.transportId = 2
						break;
					case 'CORREOS DE CHILE':
					case 'CORREO DE CHILE':
					case 'CORREOSDECHILE':
					case 'CORREODCHILE':
						this.transportId = 3
						break;
					case 'RETIRA EN ACES':
						this.transportId = 1
						break;
					default:
						this.transportId = 0
						break;
				}
		},
		getMovimientoLocal(tipocompcod, nrocomp) {
			this.clearForm()
			this.getMovimiento(tipocompcod, nrocomp)
		},
		initModuleLocal() {
			this.setTitleModule('Solicitudes de Envío')
			this.setSubTitleModule('')
/*			this.fromDateShippingsRequest = this.currentDate(-3)
			this.toDateShippingsRequest = this.currentDate()
			this.showLabel(1)
			this.initMixinShippingRequest()*/
		},
		getAllShippingsRequestLocal(page = 1) {
			let nameLocalStorage = 'Sales-status'
			let statusIds = (localStorage.getItem(nameLocalStorage) != null && localStorage.getItem(nameLocalStorage) != undefined && localStorage.getItem(nameLocalStorage) != 'null' && localStorage.getItem(nameLocalStorage) != 'undefined') ? JSON.parse(localStorage.getItem(nameLocalStorage)) : []
			if(statusIds.length == 0) {
				alert('Debe haber 1 estado como minimo para poder buscar las Solicitudes de Envío')
			} else {
				this.getAllShippingsRequest(page, statusIds)
			}
		},
		removeShippingsRequest(item) {
			if(confirm('Esta a punto de borrar la solucitud de envío "' + item.id + ' (' + item.commentary + ')".\n¿Quiere continuar? ')) {
				this.deleteShippingRequest(item.id)
			}
		},
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'addOrderTrackingsOrderResult': this.addOrderTrackingsOrderResult(response); break;
				case 'getDomicilioWithClienteResult': this.getDomicilioWithClienteResult(response); break;
				case 'getMovimientoResult': this.getMovimientoResult(response); break;
				case 'getShippingResult': this.getShippingResult(response); break;
				case 'getAllStatusResult': this.resultAxiosLocalStatus(responseLocal, response); break;
				case 'getAllTransportsResult': this.resultAxiosLocalTranspor(responseLocal, response); break;
				case 'resultGetAllTrackingsShippingRequest': this.resultAxiosLocalTrackingsShippingRequest(responseLocal, response); break;
				case 'resultGetAllShippingsRequest': this.resultAxiosLocalShippingRequest(responseLocal, response); break;
				case 'resultDeleteShippingRequest': this.resultAxiosLocalShippingRequest(responseLocal, response); break;
				case 'resultAddShippingRequestTrackingsShippingRequestPOST': this.resultAxiosLocalShippingRequest(responseLocal, response); break;
				case 'resultSaveShippingRequestPOST': this.resultAxiosLocalShippingRequest(responseLocal, response); break;
				case 'resultShowLabelGET': this.resultAxiosLocalLabel(responseLocal, response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		getAllShippingsRequestResultLocal(response) {},
		showLabelResultLocal(response) {
			if(response.data.success == true) {
				this.getAllTransports()
			} else {
				alert('Algo no salió bien al querer recuperar el formato de la etiqueta')
			}
		},
		getAllTransportsResultLocal(response) {
			if(response.data.success == true) {
				this.getAllTrackingsShippingRequest()
			} else {
				alert('Algo no salió bien al querer recuperar los transportes')
			}
		},
		getAllStatusResultLocal(response) {
			if(response.data.success == true) {
				//setTimeout(()=>{this.$refs.contextMenuStatus.$refs.btnEjecute.click()}, 300)
			} else {
				alert('Algo no salió bien al recuperar los estados')
			}
		},
		resultGetAllTrackingsShippingRequestLocal(response) {
			if(response.data.success == true) {
				this.typeStatusId = 3
				this.getAllStatus()
			} else {
				alert('Algo no salió bien al recuperar los seguimientos de las Solicitudes de Envío')
			}
		},
		getDomicilioWithClienteResult(response) {
			if(response.data.data.length == 1) {
				this.enviara = response.data.data[0].clinom + ' ' + response.data.data[0].cliape
				this.direccion = response.data.data[0].domicalle
				this.direccion = (response.data.data[0].dominro === null) ? this.direccion : this.direccion + ' ' + response.data.data[0].dominro
				this.comuna = response.data.data[0].dptodesc + ' - ' + response.data.data[0].provdesc
				this.telefono = (response.data.data[0].domitel === null) ? '' : response.data.data[0].domitel
			}
		},
        getMovimientoResultLocal(response) {
			this.analizarResultado(response)
		},
		getShippingLocal(id){
			this.clearObjectShipping()
			this.getShipping(id)
		},
		getShippingResultLocal(response){
			if(response.data.success) {
				this.$refs.btnShowShippingModalComponent.click()
			}
		},
		resultSaveShippingRequestPOSTLocal(responseLocal, response) {
			if(!this.notClose) {
				this.$refs.closeModalAttentionOrder.click()
			} else {
				this.closeModalAttentionOrder()
				this.$refs.nrocomp.focus()
			}
		},
		saveShippingRequestLocal() {
			if(this.verifyCabmovsRecipientData()) {
				this.saveShippingRequest()
			}
		},
		searchOFStarkenResultLocal(response) {
			if(this.listOfStarken.length == 1) {
				this.itemSelectedStarken = this.listOfStarken[0]
				setTimeout(()=>{this.$refs.btnShowStarkenModalComponent.click()}, 10)
			}
		},
		toPrintLabel(item) {
			console.log(item.shippingRequestRecipientData)
			let index = this.listTransports.map((el) => parseInt(el.id)).indexOf(parseInt(this.getRecipientData(item.shippingRequestRecipientData, 'TRANSPORTSID')))
			let arrayZPL = []
			let user = item.user.split(' ')
			let initials = ''
			user.forEach(e => {
				if(e.length > 0) {
					initials+= e.substring(0,1).toUpperCase()
				}
			})

			if(item.shippingRequestRecipientData.length == 1) {
				arrayZPL.push({'name': 'sendto' , 'value': this.cleanedStringZPL(this.getRecipientData(item.shippingRequestRecipientData, 'SENDTO')).toUpperCase()})
				arrayZPL.push({'name': 'address' , 'value': this.cleanedStringZPL(this.getRecipientData(item.shippingRequestRecipientData, 'ADDRESS')).toUpperCase()})
				arrayZPL.push({'name': 'comuna' , 'value': this.cleanedStringZPL(this.getRecipientData(item.shippingRequestRecipientData, 'COMUNA')).toUpperCase()})
				arrayZPL.push({'name': 'phone' , 'value': this.getRecipientData(item.shippingRequestRecipientData, 'PHONE').toUpperCase()})
				arrayZPL.push({'name': 'number_document' , 'value': this.getRecipientData(item.shippingRequestRecipientData, 'NUMBER_DOCUMENT')})
				arrayZPL.push({'name': 'email' , 'value': this.getRecipientData(item.shippingRequestRecipientData, 'EMAIL')})
				arrayZPL.push({'name': 'initials' , 'value': initials.toUpperCase()})
				arrayZPL.push({'name': 'img_zpl' , 'value': (this.listTransports[index].img_zpl == null || this.listTransports[index].img_zpl == '') ? this.listTransports[index].name : this.listTransports[index].img_zpl})
				arrayZPL.push({'name': 'paid_shipping_desc' , 'value': (item.shippingRequestRecipientData[0].paid_shipping == 0) ? 'POR PAGAR' : ''})
			}
			arrayZPL.push({'name': 'nrocomp' , 'value': this.getNrocompGenesys(item.shippingRequestGenesysCabmov, 'INT')})
			arrayZPL.push({'name': 'codbareti' , 'value': this.getCodbaretiGenesys(item.shippingRequestGenesysCabmov)})
			arrayZPL.push({'name': 'codbareti2' , 'value': item.barcode + '0001' })
			arrayZPL.push({'name': 'nrocompLegal' , 'value': this.getNrocompGenesys(item.shippingRequestGenesysCabmov, 'LEG')})
			arrayZPL.push({'name': 'total_price' , 'value': item.total_price})
			this.replaceZPLVariableFromArray(arrayZPL)
			this.toPrintWithVariables()
		},
		verifyCabmovsRecipientData() {
			let messageCabmovs = ''
			let messageRecipientData = ''
			if(this.tipocompcod == 0) {
				messageCabmovs = '\n- Sin datos de genesys'
			} else {
				this.setCabmovs(this.tipocompcod, this.fecmov, this.succod, this.codbareti, this.nrocomp)
				if(this.tipocompcodLegal > 0) {
					this.setCabmovs(this.tipocompcodLegal, this.fecmovLegal, this.succodLegal, this.codbaretiLegal, this.nrocompLegal)
				}
			}
			if(this.enviara.trim() == '' && this.direccion.trim() == '' && this.comuna.trim() == '' && this.telefono.trim() == '') {
				return confirm('ATENCION!!!' + messageCabmovs + '\nNo hay datos de envío\n\n¿Desea continuar?')
			} else if(this.enviara.trim() == '' || this.direccion.trim() == '' || this.comuna.trim() == '' || this.telefono.trim() == '') {
				messageRecipientData = '\n- Campos de datos de envío sin completar \n   '
				messageRecipientData+= (this.enviara.trim() == '') ? ' * Enviar a' : ''
				messageRecipientData+= (this.direccion.trim() == '') ? ' * Dirección' : ''
				messageRecipientData+= (this.comuna.trim() == '') ? ' * Comuna' : ''
				messageRecipientData+= (this.telefono == null || this.telefono.trim() == '') ? ' * Telefono' : ''
			} else {
				let index = this.listTransports.map((el) => parseInt(el.id)).indexOf(parseInt(this.transportId))
				this.setRecipientData(this.enviara.trim(), this.rut.trim(), this.email.trim(), this.direccion.trim(), this.comuna.trim(), this.telefono.trim(), this.cobro, this.transportId, this.listTransports[index].name)
			}
			if(messageCabmovs != '' || messageRecipientData != '') {
				if(confirm("ATENCION!!!" + messageCabmovs + messageRecipientData + '\n\n¿Desea guardar de todas formas?')){
					if(this.transportId == 0) {
						alert('ATENCION!!!\nDebe elegir el transporte')
						return false
					}
					let index = this.listTransports.map((el) => parseInt(el.id)).indexOf(parseInt(this.transportId))
					this.setRecipientData(this.enviara.trim(), this.direccion.trim(), this.comuna.trim(), this.telefono.trim(), this.cobro, this.transportId, this.listTransports[index].name)
					return true
				}
			} else {
				return true
			}
		}
	},
	components: {
		'pagination': Pagination,
		'starken-modal-component': StarkenModalComponent,
		'shipping-modal-component': ShippingModalComponent,
		'context-menu': ContextMenu,
		'list-shippings-request-component': ListShippingsRequestComponent,
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
.btn-outline-primary {
	font-size: 20px;
	color: #f0f;
}
</style>